import { NavLink } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { prefixPath } from './util';
import { useTranslation } from 'react-i18next';

function LocalizedLink(props) {
    const { to, className, children } = props;
    const { i18n } = useTranslation();
    const [internalUrl, setInternalUrl] = useState(null);
    const [externallUrl, setExternallUrl] = useState(null);

    useEffect(() => {
        if (!to) {
            setInternalUrl("/")
        }
        else {
            if (to.startsWith("https://") || to.startsWith("http://")) {
                setExternallUrl(to)
            }
            else {
                setInternalUrl(to)
            }
        }
    }, [to])

    return (
        internalUrl ?
            <NavLink
                className={className + " text-decoration-none"}
                to={prefixPath(internalUrl, i18n.language)}
                data-test-id={props?.dti ? props.dti : null}
            >
                {children}
            </NavLink> :
            <a data-test-id={props?.dti ? props.dti : null} className={className + " text-decoration-none"} href={externallUrl}>{children}</a>
    )
}

export default LocalizedLink;